import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../../public/img/ajax-loader.gif';
const _hoisted_1 = {
  key: 1,
  class: "px-6 py-2"
};
const _hoisted_2 = {
  style: {
    "margin": "10px"
  }
};
import MainHeader from "@/components/MainHeader.vue";
import Loader from "@/components/Loader.vue";
import LlCheckbox from "@/components/LlCheckbox.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { reactive, onMounted } from "vue";
import axios from "axios";
export default {
  __name: 'CompanyReset',
  props: {
    userService: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const companyResetState = reactive({
      loading: false,
      me: {},
      resetting: false,
      matters: true,
      entries: true
    });
    onMounted(async () => {
      const me = await props.userService.getMe();
      companyResetState.me = me;
      if (me.company.status != "test") {
        // return props.state.go("home");
      }
      if (props.stateParams.state == "test") {
        companyResetState.loading = true;
        axios({
          url: "/me/reset",
          method: "POST",
          data: {
            test: true
          }
        }).then(() => {
          window.location.reload();
          props.state.go("home");
        }).catch(err => {
          bootbox.alert(`Failed to reset the account for some reason - ${err.body.message}`);
          companyResetState.loading = false;
        });
      }
    });
    function reset() {
      bootbox.confirm(`Are you sure? This will delete ALL DATA in the ${companyResetState.me.company.name} account.`, function (result) {
        if (result) {
          companyResetState.resetting = true;
          axios({
            url: "/me/reset",
            method: "POST",
            data: {
              matters: companyResetState.matters,
              entries: companyResetState.entries
            }
          }).then(() => {
            // must totally reload because otherwise we run into caching issues with mattermanager and other services
            window.location.reload();
          }).catch(() => {
            props.alerts.error(error);
            companyResetState.resetting = false;
          });
        }
      });
    }
    return (_ctx, _cache) => {
      return companyResetState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Reset Account',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: 'Reset Account',
        warning: true
      }), _createElementVNode("p", null, " Resetting the account with remove ALL information from it and seed it with a standard set of data (clients, " + _toDisplayString(companyResetState.me?.terms?.matter) + "s, emails, tasks, invoices etc.) ", 1), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        color: "error",
        id: "reset-account-button",
        disabled: companyResetState.resetting,
        onClick: _cache[0] || (_cache[0] = $event => reset())
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Reset Account ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _withDirectives(_createElementVNode("span", null, [...(_cache[4] || (_cache[4] = [_createElementVNode("img", {
        src: _imports_0
      }, null, -1), _createTextVNode(" Resetting...", -1)]))], 512), [[_vShow, companyResetState.resetting]])]), _withDirectives(_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("p", null, "...after reset then", -1)), _createVNode(LlCheckbox, {
        modelValue: companyResetState.matters,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => companyResetState.matters = $event),
        label: `add demo ${companyResetState.me?.terms?.matter}s`
      }, null, 8, ["modelValue", "label"]), _withDirectives(_createVNode(LlCheckbox, {
        modelValue: companyResetState.entries,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => companyResetState.entries = $event),
        label: "add demo time entries and expenses"
      }, null, 8, ["modelValue"]), [[_vShow, companyResetState.matters]])], 512), [[_vShow, !companyResetState.resetting]])]));
    };
  }
};